module.exports = __webpack_public_path__ + "img/hover_icon_manejo_requisicion_materiales_y_equipos.999d5e52.svg";